import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { useEmailTemplate } from "@mibuildweb/hooks";

export const useOrderInfoCardEmailsViewModel = () => {
  const [emailTemplates, setEmailTemplates] = useState([]);
  const { isLoading, getEmailTemplatesByOrderTemplateId } = useEmailTemplate();
  const stateManager = useComponentState();
  const [emailHistory, setEmailHistory] = useState({});

  const handleGetEmailTemplateDetails = (templateId) => {
    getEmailTemplatesByOrderTemplateId(templateId, {
      onSuccess: setEmailTemplates,
    });
  };

  const getEmailHistory = (id) =>
    stateManager.run(async () => {
      const response = await taskService.order.getEmailHistory({
        orderId: id,
      });

      if (response.status === HTTP_STATUSES.OK) {
        const recentEmails = response.data.reduce((acc, email) => {
          if (
            !acc[email.emailType] ||
            new Date(email.createdOn) > new Date(acc[email.emailType].createdOn)
          ) {
            acc[email.emailType] = email;
          }
          return acc;
        }, {});

        setEmailHistory(recentEmails);
      }
    });

  return {
    isLoading: isLoading || stateManager.isBusy(),
    emailHistory,
    emailTemplates,
    getEmailTemplateDetails: handleGetEmailTemplateDetails,
    getEmailHistory,
  };
};
